
// // src/hooks/useUploadSelfie.js
// import { useState, useCallback } from 'react';
// import { storage } from '../firebase';
// import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

// export function useUploadSelfie() {
//     const [uploading, setUploading] = useState(false);
//     const [err, setErr] = useState('');

//     const uploadSelfie = useCallback(async (file, requestId) => {
//         if (!file) return null;
//         setUploading(true); setErr('');
//         try {
//             const fileName = `${Date.now()}-${file.name}`;
//             const storageRef = ref(storage, `visitorSelfies/${requestId}/${fileName}`);
//             await uploadBytes(storageRef, file);
//             const url = await getDownloadURL(storageRef);
//             setUploading(false);
//             return url;
//         } catch (e) {
//             setErr(e?.message || 'Failed to upload selfie');
//             setUploading(false);
//             return null;
//         }
//     }, []);

//     return { uploadSelfie, uploading, err };
// }


// src/hooks/useUploadSelfie.js
import { useState, useCallback } from 'react';
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export function useUploadSelfie() {
    const [uploading, setUploading] = useState(false);
    const [err, setErr] = useState('');

    const uploadSelfie = useCallback(async (file, requestId) => {
        if (!file) return null;
        setUploading(true); setErr('');
        try {
            const fileName = `${Date.now()}-${file.name}`;
            const storageRef = ref(storage, `visitorSelfies/${requestId}/${fileName}`);
            await uploadBytes(storageRef, file);
            const url = await getDownloadURL(storageRef);
            setUploading(false);
            return url;
        } catch (e) {
            setErr(e?.message || 'Failed to upload selfie');
            setUploading(false);
            return null;
        }
    }, []);

    return { uploadSelfie, uploading, err };
}